/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setpoint_Temp_Open_WindowInputs */



/**
* | output |
* | --- |
* | "Open window: th. heads are closed" |
*
* @param {Setpoint_Temp_Open_WindowInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const setpoint_temp_open_window = /** @type {((inputs?: Setpoint_Temp_Open_WindowInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setpoint_Temp_Open_WindowInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Open window: th. heads are closed")
	return /** @type {LocalizedString} */ ("Fenêtre ouverte: les têtes th. sont fermées")
});